var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBehance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -0.000488281,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_125_7590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2565 22.1042C20.2565 20.7842 19.6286 19.8085 18.3315 19.4428C19.2779 18.9921 19.7715 18.3092 19.7715 17.2471C19.7715 15.1528 18.2058 14.6421 16.3994 14.6421H11.4258V25.1571H16.5386C18.4558 25.1571 20.2565 24.2407 20.2565 22.1042ZM13.7444 16.4371H15.9201C16.7565 16.4371 17.5094 16.6714 17.5094 17.6385C17.5094 18.5314 16.9236 18.8907 16.0951 18.8907H13.7444V16.4371ZM13.7436 23.3714V20.4757H16.2708C17.2915 20.4757 17.9372 20.8999 17.9372 21.9771C17.9372 23.0392 17.1665 23.3714 16.2229 23.3714H13.7436Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.85 25.3562C26.6743 25.3562 27.8557 24.537 28.4243 22.7955H26.5728C26.3735 23.4455 25.5521 23.7891 24.915 23.7891C23.6857 23.7891 23.04 23.0712 23.04 21.8512H28.5493C28.7235 19.4098 27.3635 17.3291 24.8493 17.3291C22.5214 17.3291 20.9414 19.0734 20.9414 21.3584C20.9414 23.7298 22.4385 25.3562 24.85 25.3562V25.3562ZM24.7843 18.9091C25.8378 18.9091 26.3678 19.5262 26.4564 20.5355H23.0428C23.1121 19.5348 23.7785 18.9091 24.7843 18.9091Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6172 15.1943H26.8943V16.2301H22.6172V15.1943Z",
    fill: "#383838"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_125_7590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.1429,
    height: 17.1429,
    fill: "white",
    transform: "translate(11.4277 11.4282)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehance);
export default __webpack_public_path__ + "static/media/Behance.3fac276c3d758e893982d105fb153d67.svg";
export { ForwardRef as ReactComponent };